<template>
  <h1>Error 404 not found</h1>
</template>
<script lang="ts" setup></script>
<style scoped></style>
